import { render, staticRenderFns } from "./ProjetoList.vue?vue&type=template&id=7f0f12ff&"
import script from "./ProjetoList.vue?vue&type=script&lang=js&"
export * from "./ProjetoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports